import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {AppLanguageService} from '../i18n/app-language.service';

@Injectable({providedIn: 'root'})
@Pipe({
  name: 'smNumber',
  standalone: true,
  pure: false,
})
export class NumberPipe implements PipeTransform {
  private formatter?: Intl.NumberFormat;
  private formatterLanguage = '';
  private formatterPrecision = -1;
  constructor(private readonly appLanguageService: AppLanguageService) {}

  transform(value: number | null | undefined, maximumFractionDigits = 3): string {
    if (value === null || value === undefined) {
      return '';
    }

    const language = this.appLanguageService.languageCode;
    if (!this.formatter || language !== this.formatterLanguage || maximumFractionDigits !== this.formatterPrecision) {
      this.formatter = new Intl.NumberFormat(language, {maximumFractionDigits});
      this.formatterLanguage = language;
      this.formatterPrecision = maximumFractionDigits;
    }
    return this.formatter.format(value);
  }
}
